import React, {useContext} from "react"
import HomeCatBoxes from "../home/homeCatBoxes/HomeCatBoxes"
import ShowroomHomepageSection from "../home/howItWorks/ShowroomHomepageSection"
import HowItWorks from "../home/howItWorks/HowItWorks"
import FindPerfectBike from "../home/FindPerfectBike/FindPerfectBike"
import ServiceCenters from "../home/serviceCenters/ServiceCenters"
import GoogleReviews from "../googleReviews/GoogleReviews"
import {staticDataHowItWorks} from "../home/howItWorks/contentData"
import {useRouter} from "next/router"
import LogoGallery from "../home/logoGallery/LogoGallery"
import DataContext from "../../context/DataContext"
import {useTranslation} from "next-i18next"
import Typography from "../reusable/Typography/Typography"
import ConsultationHeader from "./components/ConsultationHeader"

type Props = {
    reviews: any[]
}

export default function ConsultationContent({reviews}: Props) {
	const router = useRouter()
	const {locale} = router
	const {organizationSlug, pageProps} = useContext(DataContext)
	const strapiContent = pageProps?.strapiContent
	const dataHowItWorks = staticDataHowItWorks[locale]
	const organization = organizationSlug ? organizationSlug : null
	const strapiContentData: any = organization ? strapiContent : strapiContent

	const {data, loading} = strapiContentData
	const homepageContent = loading ? {} : data?.homepage?.attributes

	const {brandImages} = homepageContent
	const {t} = useTranslation()
	return (
		<>

			<main className="container my-5">

				<ConsultationHeader bannerTitle={t("get-contacted-card-title")}
					listTitle={t("suggestion-banner-list-title")}
					stepsWithIconsContent={[{
						header: <Typography variant="bodySmBlack">1</Typography>, description: t("consultation-bulletpoint-1")
					},
					{header: <Typography variant="bodySmBlack">2</Typography>, description: t("consultation-bulletpoint-2")},
					{header: <Typography variant="bodySmBlack">3</Typography>, description: t("consultation-bulletpoint-3")
					}]}
					bgImageSrc={"/assets/images/consultation-bg.jpg"}
					link={t("link-meeting-consultation")}
				/>
				<HomeCatBoxes />
				<ShowroomHomepageSection />
				<HowItWorks blockTilesHowItWorks={dataHowItWorks}
					hasOptionalText
					className="pt-0 pb-5 pt-md-5 mt-3 mt-md-5" />
				<FindPerfectBike />
				<LogoGallery isSlider
					brands={brandImages}/>
				<div className="my-5"/>
				<ServiceCenters />
				{reviews &&
                            <GoogleReviews reviews={reviews}/>}
			</main>
		</>
	)
}
